package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider

import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.BlackOverlay
import com.anjuros.website.components.TemplatesHeader
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.detectMode
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.language.isContentSelected

import com.anjuros.website.components.setMeta
import com.anjuros.website.components.shared.TemplatePromoFab
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.modules.Template
import com.anjuros.website.templates.template6.components.Template6OverflowMenu
import com.anjuros.website.templates.template6.components.Template6Header
import com.anjuros.website.templates.template6.sections.Template6ContactSection
import com.anjuros.website.templates.template6.sections.Template6FAQSection
import com.anjuros.website.templates.template6.sections.Template6FooterSection
import com.anjuros.website.templates.template6.sections.Template6InfoSection
import com.anjuros.website.templates.template6.sections.Template6MainSection
import com.anjuros.website.templates.template6.sections.Template6ReviewsSection
import com.anjuros.website.templates.template6.sections.Template6ServiceSection
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import kotlinx.browser.localStorage

import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun ElectricianWebsiteDesignUk() {
    var lang by remember { mutableStateOf(Language.EN) }
    val uiMode = remember { mutableStateOf<UiMode?>(null) }
    var showModeToggleSpotlight by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        setMeta(
            title = "Electrician website design UK | Get more enquiries",
            description = "Website design for electricians in the UK. Get found on Google and generate more local enquiries for your services.",
            url = "https://www.soletraderwebsite.co.uk/electrician-website-design-uk",
            image = "https://www.soletraderwebsite.co.uk/template6_hero.jpg"
        )
        lang = detectLanguage()
        uiMode.value = detectMode()
        showModeToggleSpotlight =
            uiMode.value != null && localStorage.getItem(HintBoxDisplay).isNullOrEmpty()
    }

    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }


    var menuOpened by remember { mutableStateOf(false) }

    val contentMode = uiMode.value ?: UiMode.NORMAL
    CompositionLocalProvider(
        LocalLanguage provides languageContext,
        LocalUiMode provides contentMode
    ) {

        Box(modifier = Modifier.fillMaxSize()) {

            Column(
                modifier = Modifier.fillMaxSize().zIndex(2.0),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Template6MainSection()
                Template6ServiceSection()
                Template6InfoSection()
                Template6ReviewsSection()
                Template6FAQSection()
                Template6ContactSection()
                Template6FooterSection()

            }
            if (showModeToggleSpotlight) {
                BlackOverlay()
            }
            Column(
                modifier = Modifier.fillMaxWidth().align(Alignment.TopCenter)
                    .position(Position.Fixed)
                    .zIndex(100)

            ) {

                TemplatesHeader(
                    template = Template.Template6,
                    showModeToggleSpotlight = showModeToggleSpotlight,
                    onDismissSpotlight = {
                        showModeToggleSpotlight = false
                    },
                    contentModeSelected = uiMode.value.isContentSelected(),
                    onChangeMode = { newMode ->
                        uiMode.value = newMode
                        changeMode(newMode)
                    }
                )

                Template6Header { menuOpened = true }
            }

            if (menuOpened) {
                Template6OverflowMenu { menuOpened = false }
            }

            TemplatePromoFab()
        }
    }
}